import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('tasks');

const tasksRoutes = [
  {
    path: '/tasks',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: 'tasks',
    },
    children: [
      {
        path: ':slug?',
        name: 'tasks',
        meta: { showNav: true, feature: 'tasks' },
        props: true,
        component: loadView('Tasks'),
      },
    ],
  },
];

export default tasksRoutes;
